/** @jsxImportSource @emotion/react */
import React, { useState } from "react";
import { css } from "@emotion/react";
import {
  Column,
  Text,
  TEXT_VARIANTS,
  EntityLink,
  AudioCard,
  HighlightCard,
  PersonCard,
  VideoCard,
  NoteCard,
  TextCard,
  WebsiteCard,
} from "..";
import { COLORS } from "../../shared/theme";

const CollapsibleText: React.FC<{ content: string }> = ({ content }) => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const maxLength = 300;

  return (
    <Text
      variant={TEXT_VARIANTS.T20}
      css={css`
        cursor: ${isCollapsed && content.length > maxLength
          ? "pointer"
          : "default"};
        color: ${COLORS.SILVER};
      `}
      onClick={() => setIsCollapsed(false)}
    >
      {isCollapsed && content.length > maxLength
        ? content.slice(0, maxLength).concat("...")
        : content}
    </Text>
  );
};

export const Feed: React.FC = () => (
  <Column
    gap={50}
    css={css`
      padding-bottom: 50px;
    `}
  >
    <Column>
      <WebsiteCard />
      <Column
        gap={5}
        css={css`
          padding: 10px;
        `}
      >
        <Text
          variant={TEXT_VARIANTS.T20}
          css={css`
            color: ${COLORS.SILVER};
          `}
        >
          <EntityLink to="/asdf">{"Yanis Markin"}</EntityLink>
          {" added 2h ago"}
        </Text>
        <CollapsibleText content="I remember when I first learned this, it changed how I thought about design, and I think really reinforced the value of subtlety in design. Humans perceive things in a lot more fidelity then we consciously think they do. I remember when I first learned this, it changed how I thought about design, and I think really reinforced the value of subtlety in design. Humans perceive things in a lot more fidelity then we consciously think they do." />
      </Column>
    </Column>
    <Column>
      <PersonCard />
      <Column
        gap={5}
        css={css`
          padding: 10px;
        `}
      >
        <Text
          variant={TEXT_VARIANTS.T20}
          css={css`
            color: ${COLORS.SILVER};
          `}
        >
          <EntityLink to="/username">{"Sari Azout"}</EntityLink>
          {" connected to "}
          <EntityLink to="/collection/collectionId">{"Good Design"}</EntityLink>
          {" 5h ago"}
        </Text>
      </Column>
    </Column>
    <VideoCard />
    <AudioCard />
    <HighlightCard />
    <NoteCard />
    <TextCard />
  </Column>
);
